/* =========================================================
   Flexi Canap · page d'accueil (gabarit NoClout)
   Un seul fichier pour toutes les sections FC. Chaque section porte
   data-fc="..." ; on initialise chaque racine une seule fois (dataset.fcPret),
   et on relance une section quand l'éditeur de thème la reconstruit.
   ========================================================= */
(function () {
  'use strict';
  if (window.FC) return; // le fichier peut être appelé par plusieurs sections
  var reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobile = window.matchMedia('(max-width: 749px)');
  var FC = window.FC = {};

  /* ---------- Entête : intro, bandeau, entête qui se cache, rubriques, tiroir ---------- */
  FC.haut = function (racine) {
    var root = document.documentElement;
    var intro = racine.querySelector('.fc-intro');
    var cible = racine.querySelector('.fc-logo-entete');
    var m = [];

    /* 1. Intro « Descente » : logo en grand, pause, puis il se pose dans l'entête (FLIP 900 ms) */
    function fin() { m.forEach(clearTimeout); root.classList.remove('fc-avec-intro'); if (intro) intro.classList.add('fc-fini'); }
    FC.finIntro = fin;
    /* la décision (jouer ou non) est prise dès l'analyse de la page par le petit script en ligne de la section */
    if (intro && !intro.classList.contains('fc-fini')) {
      {
        root.classList.add('fc-avec-intro');
        requestAnimationFrame(function () { requestAnimationFrame(function () { intro.classList.add('fc-vu'); }); });
        m.push(setTimeout(function () {
          var l = intro.querySelector('.fc-intro__logo'), a = l.getBoundingClientRect(), b = cible.getBoundingClientRect();
          var s = b.width / a.width, dx = (b.left + b.width / 2) - (a.left + a.width / 2), dy = (b.top + b.height / 2) - (a.top + a.height / 2);
          /* Le logo monte et rétrécit vers l'entête en s'effaçant (comme la référence) : il a totalement disparu
             avant que la page et le logo de l'entête n'apparaissent. Jamais deux logos à l'écran en même temps. */
          l.style.transition = 'transform .9s cubic-bezier(.76,0,.24,1), opacity .45s ease .35s';
          l.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(' + s + ')';
          l.style.opacity = '0';
          m.push(setTimeout(function () {
            root.classList.remove('fc-avec-intro');
            intro.querySelector('.fc-intro__voile').style.opacity = '0';
          }, 850));
          m.push(setTimeout(fin, 1300));
        }, 800));
        ['click', 'wheel', 'keydown', 'touchstart'].forEach(function (ev) { window.addEventListener(ev, fin, { once: true, passive: true }); });
      }
    }

    /* 2. Bandeau d'annonce : un message toutes les N s, glissement vers le haut, boucle sans saut */
    var piste = racine.querySelector('.fc-annonce__piste');
    if (piste && !reduit && piste.children.length > 2) {
      var n = piste.children.length - 1, i = 0, pas = parseFloat(piste.getAttribute('data-intervalle') || '3.5') * 1000;
      setInterval(function () {
        i++; piste.style.transition = ''; piste.style.transform = 'translateY(' + (-piste.children[0].offsetHeight * i) + 'px)';
        if (i === n) setTimeout(function () { piste.style.transition = 'none'; piste.style.transform = 'none'; i = 0; }, 600);
      }, pas);
    }

    /* 3. Entête : cachée quand on descend, revient quand on remonte.
          Lecture du défilement une fois par image (rAF) et seuil de 10 px dans chaque sens,
          pour éviter les va-et-vient sur les petits mouvements. */
    var haut = racine.querySelector('.fc-haut');
    if (haut) {
      var dernier = window.scrollY, cumul = 0, attente = false;
      var lire = function () {
        attente = false;
        var y = window.scrollY, d = y - dernier;
        dernier = y;
        if (y < 120) { haut.classList.remove('fc-cache'); cumul = 0; return; }
        cumul = (cumul > 0) === (d > 0) ? cumul + d : d;
        if (cumul > 10) haut.classList.add('fc-cache');
        else if (cumul < -10) haut.classList.remove('fc-cache');
      };
      window.addEventListener('scroll', function () { if (!attente) { attente = true; requestAnimationFrame(lire); } }, { passive: true });
    }

    /* 3 bis. Défilement doux à la molette (ordinateur) : la page glisse et ralentit en douceur.
          Laisse la main au navigateur dès qu'un élément interne défile ou qu'une fenêtre est ouverte. */
    if (racine.getAttribute('data-doux') === 'true') FC.doux(parseFloat(racine.getAttribute('data-inertie') || '0.1'));

    /* 3 ter. Panier et recherche : ouvrent le tiroir panier et la recherche du thème quand ils existent */
    var panier = racine.querySelector('[data-fc-panier]'), recherche = racine.querySelector('[data-fc-recherche]');
    if (panier) panier.addEventListener('click', function (e) {
      var t = document.getElementById('cart-drawer');
      if (t && typeof t.open === 'function') { e.preventDefault(); t.open(); }
    });
    if (recherche) recherche.addEventListener('click', function (e) {
      var m = document.getElementById('search-modal');
      if (m && typeof m.showDialog === 'function') { e.preventDefault(); m.showDialog(); }
    });

    /* 4. Rubriques : la flèche fait défiler la liste */
    var rl = racine.querySelector('.fc-rubriques__liste'), suite = racine.querySelector('.fc-rubriques__suite');
    if (rl && suite) suite.addEventListener('click', function () { rl.scrollBy({ left: 160 }); });

    /* 5. Tiroir du menu */
    var tiroir = racine.querySelector('.fc-tiroir'), bouton = racine.querySelector('.fc-ouvrir-menu');
    if (tiroir && bouton) {
      function basculer(o) {
        tiroir.classList.toggle('fc-ouvert', o); bouton.setAttribute('aria-expanded', o ? 'true' : 'false');
        tiroir.setAttribute('aria-hidden', o ? 'false' : 'true');
        if (o) { var f = tiroir.querySelector('.fc-tiroir__fermer'); if (f) f.focus(); } else bouton.focus();
      }
      bouton.addEventListener('click', function () { basculer(true); });
      tiroir.querySelectorAll('[data-fc-fermer]').forEach(function (b) { b.addEventListener('click', function () { basculer(false); }); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && tiroir.classList.contains('fc-ouvert')) basculer(false); });
    }
  };

  /* ---------- Défilement doux (molette, ordinateur) ---------- */
  FC.doux = function (inertie) {
    if (FC.douxActif || reduit || (window.Shopify && Shopify.designMode) || !window.matchMedia('(pointer: fine)').matches) return;
    FC.douxActif = true;
    var root = document.documentElement, cible = window.scrollY, courant = cible, actif = false, avant = 0;
    root.classList.add('fc-doux');
    function maxY() { return root.scrollHeight - window.innerHeight; }
    function bloque(el) {
      if (root.hasAttribute('scroll-lock') || document.querySelector('dialog[open], .fc-tiroir.fc-ouvert')) return true;
      for (; el && el !== document.body && el !== root; el = el.parentElement) {
        var st = getComputedStyle(el);
        if (/(auto|scroll)/.test(st.overflowY) && el.scrollHeight > el.clientHeight + 1) return true;
      }
      return false;
    }
    function boucle(t) {
      var dt = avant ? Math.min(64, t - avant) : 16.7; avant = t;
      var k = 1 - Math.pow(1 - inertie, dt / 16.7);
      courant += (cible - courant) * k;
      if (Math.abs(cible - courant) < 0.4) { courant = cible; actif = false; avant = 0; }
      window.scrollTo(0, courant);
      if (actif) requestAnimationFrame(boucle);
    }
    window.addEventListener('wheel', function (e) {
      if (e.ctrlKey || e.defaultPrevented || bloque(e.target)) return;
      e.preventDefault();
      var d = e.deltaY * (e.deltaMode === 1 ? 40 : e.deltaMode === 2 ? window.innerHeight : 1);
      if (!actif) { cible = courant = window.scrollY; }
      cible = Math.max(0, Math.min(maxY(), cible + d));
      if (!actif) { actif = true; requestAnimationFrame(boucle); }
    }, { passive: false });
    /* clavier, barre de défilement, ancres : on se recale sans lutter */
    window.addEventListener('scroll', function () { if (!actif) cible = courant = window.scrollY; }, { passive: true });
  };

  /* ---------- Héros : carrousel (téléphone ; ordinateur si réglé) ---------- */
  FC.heros = function (racine) {
    var hp = racine.querySelector('.fc-heros__piste'), pts = racine.querySelectorAll('.fc-points button');
    if (!hp || pts.length < 2) return;
    var surOrdi = racine.getAttribute('data-ordi') === 'true';
    var delai = parseFloat(racine.getAttribute('data-delai') || '4') * 1000, d = 0, minuteur = null;
    function actif() { return mobile.matches || surOrdi; }
    function aller(k) { d = (k + pts.length) % pts.length; hp.style.transform = actif() ? 'translateX(' + (-100 * d) + '%)' : 'none'; pts.forEach(function (b, j) { b.setAttribute('aria-current', j === d ? 'true' : 'false'); }); }
    function relancer() { clearInterval(minuteur); if (actif() && !reduit) minuteur = setInterval(function () { aller(d + 1); }, delai); }
    pts.forEach(function (b, j) { b.addEventListener('click', function () { aller(j); relancer(); }); });
    var x0 = null;
    hp.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    hp.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) { aller(d + (dx < 0 ? 1 : -1)); relancer(); } x0 = null; });
    var change = function () { aller(0); relancer(); };
    if (mobile.addEventListener) mobile.addEventListener('change', change); else mobile.addListener(change);
    aller(0); relancer();
  };

  /* ---------- Grilles : sur téléphone, la jauge suit l'image affichée ---------- */
  FC.grille = function (racine) {
    racine.querySelectorAll('.fc-carte__piste').forEach(function (pi) {
      var j = pi.parentNode.querySelector('.fc-carte__jauge i'); if (!j) return;
      var n = parseInt(j.parentNode.getAttribute('data-n') || '2', 10);
      pi.addEventListener('scroll', function () { var r = pi.scrollLeft / (pi.scrollWidth - pi.clientWidth || 1); j.style.transform = 'translateX(' + (r * (n - 1) * 100) + '%)'; }, { passive: true });
    });
  };

  /* ---------- Mesurer ma porte : entrée du visuel quand la section est à moitié visible ---------- */
  FC.porte = function (racine) {
    if (!('IntersectionObserver' in window)) { racine.classList.add('fc-ouvert'); return; }
    var o = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { racine.classList.add('fc-ouvert'); o.disconnect(); } }); }, { threshold: .45 });
    o.observe(racine);
    if (racine.querySelector('model-viewer')) FC.lecteur3d();
  };

  /* ---------- Lecteur 3D (<model-viewer>) : celui de Shopify, sinon la bibliothèque officielle de Google ---------- */
  FC.lecteur3d = function () {
    if (FC.l3d) return;
    FC.l3d = true;
    function google() {
      if (!window.customElements || customElements.get('model-viewer')) return;
      var s = document.createElement('script');
      s.type = 'module';
      s.src = 'https://ajax.googleapis.com/ajax/libs/model-viewer/3.5.0/model-viewer.min.js';
      document.head.appendChild(s);
    }
    /* on laisse 2 s au lecteur de Shopify pour déclarer <model-viewer> ; au-delà, on charge celui de Google */
    function attendre() {
      if (!window.customElements) return;
      var fini = false;
      customElements.whenDefined('model-viewer').then(function () { fini = true; });
      setTimeout(function () { if (!fini) google(); }, 2000);
    }
    if (window.Shopify && Shopify.loadFeatures) {
      try { Shopify.loadFeatures([{ name: 'model-viewer-ui', version: '1.0', onLoad: attendre }]); }
      catch (e) { google(); }
      setTimeout(google, 6000); /* filet de sécurité si le chargement de Shopify ne répond jamais */
    } else google();
  };

  /* ---------- Pied de page : politiques en accordéon (téléphone) ---------- */
  FC.pied = function (racine) {
    var po = racine.querySelector('.fc-politiques'), pb = po && po.querySelector('.fc-politiques__titre');
    if (pb) pb.addEventListener('click', function () { var o = po.classList.toggle('fc-ouvert'); pb.setAttribute('aria-expanded', o); pb.querySelector('i').textContent = o ? '−' : '+'; });
  };

  /* ---------- Fenêtres <dialog> : ouverture / fermeture en fondu, page bloquée derrière ---------- */
  function lireMemoire(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function ecrireMemoire(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  FC.ouvrir = function (d) {
    if (d.open) return;
    if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
    /* focus sur la carte plutôt que sur la croix (évite l'anneau de focus à l'ouverture) */
    var af = d.querySelector('[autofocus]'); if (af) af.focus({ preventScroll: true });
    document.documentElement.classList.add('fc-bloque');
    requestAnimationFrame(function () { requestAnimationFrame(function () { d.classList.add('fc-visible'); }); });
  };
  FC.fermer = function (d, apres) {
    if (!d.open) return;
    d.classList.remove('fc-visible');
    setTimeout(function () {
      if (typeof d.close === 'function') d.close(); else d.removeAttribute('open');
      if (!document.querySelector('dialog.fc-modale[open]')) document.documentElement.classList.remove('fc-bloque');
      if (apres) apres();
    }, reduit ? 0 : 300);
  };
  /* Échap et clic sur le voile ferment la fenêtre (avec l'animation) */
  function brancherFermeture(d, quand) {
    d.addEventListener('cancel', function (e) { e.preventDefault(); quand(); });
    d.addEventListener('click', function (e) { if (e.target === d) quand(); });
  }

  /* ---------- Social : rangée qui défile en continu, se tire à la souris ou au doigt, s'ouvre au clic ---------- */
  FC.social = function (racine) {
    var fen = racine.querySelector('.fc-social__fenetre'), piste = racine.querySelector('.fc-social__piste');
    var d = racine.querySelector('.fc-modale--post'), boite = d && d.querySelector('.fc-modale__boite');
    if (!fen || !piste) return;
    var vitesse = reduit ? 0 : parseFloat(racine.getAttribute('data-vitesse') || '35');
    var items = piste.querySelectorAll('.fc-post'), n = items.length / 2;
    var pos = 0, periode = 1, survol = false, tire = false, visible = true, avant = 0, reprise = 0;

    /* période = largeur d'un jeu complet de publications ; on ajoute des copies si l'écran est plus large */
    function mesurer() {
      if (n < 1) return;
      var t = piste.querySelectorAll('.fc-post');
      periode = t[n].offsetLeft - t[0].offsetLeft || 1;
      var garde = 0;
      while (piste.scrollWidth < fen.clientWidth + periode + 10 && garde++ < 6) {
        for (var i = 0; i < n; i++) { var c = t[i].cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.setAttribute('tabindex', '-1'); c.removeAttribute('data-shopify-editor-block'); piste.appendChild(c); }
      }
    }
    mesurer();
    window.addEventListener('resize', mesurer);

    function boucle(t) {
      var dt = avant ? Math.min(64, t - avant) : 16; avant = t;
      var arret = survol || tire || !visible || (d && d.open) || t < reprise;
      if (!arret && vitesse > 0) pos += vitesse * dt / 1000;
      pos = ((pos % periode) + periode) % periode;
      piste.style.transform = 'translate3d(' + (-pos).toFixed(2) + 'px,0,0)';
      requestAnimationFrame(boucle);
    }
    requestAnimationFrame(boucle);
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }).observe(fen);
    fen.addEventListener('mouseenter', function () { survol = true; });
    fen.addEventListener('mouseleave', function () { survol = false; });

    /* tirer la rangée (souris ou doigt) ; un vrai glissé n'ouvre pas la publication */
    var x0 = 0, pos0 = 0, bouge = false, idp = null;
    fen.addEventListener('pointerdown', function (e) {
      if (e.button !== 0) return;
      idp = e.pointerId; x0 = e.clientX; pos0 = pos; bouge = false; tire = true;
    });
    fen.addEventListener('pointermove', function (e) {
      if (idp !== e.pointerId) return;
      var dx = e.clientX - x0;
      if (!bouge && Math.abs(dx) > 6) { bouge = true; fen.classList.add('fc-tire'); try { fen.setPointerCapture(idp); } catch (er) {} }
      if (bouge) pos = pos0 - dx;
    });
    function lacher(e) {
      if (idp !== e.pointerId) return;
      idp = null; tire = false; fen.classList.remove('fc-tire');
      if (e.pointerType !== 'mouse') reprise = performance.now() + 1500;
    }
    fen.addEventListener('pointerup', lacher);
    fen.addEventListener('pointercancel', lacher);
    fen.addEventListener('click', function (e) {
      if (bouge) { e.preventDefault(); e.stopPropagation(); bouge = false; return; }
      var b = e.target.closest('.fc-post');
      if (b && d) ouvrirPost(b.getAttribute('data-i'));
    }, true);

    function ouvrirPost(i) {
      var src = racine.querySelector('.fc-postg[data-i="' + i + '"]');
      if (!src) return;
      boite.innerHTML = '';
      var c = src.cloneNode(true);
      c.querySelectorAll('img[loading="lazy"]').forEach(function (im) { im.loading = 'eager'; });
      boite.appendChild(c);
      FC.ouvrir(d);
      var v = boite.querySelector('video');
      if (v) { v.muted = true; v.playsInline = true; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
    }
    if (d) {
      var fermerPost = function () { FC.fermer(d, function () { boite.innerHTML = ''; }); };
      brancherFermeture(d, fermerPost);
      d.querySelector('.fc-modale__fermer').addEventListener('click', fermerPost);
    }
  };

  /* ---------- Pop-up e-mail : N s après l'arrivée, puis plus pendant N jours ; jamais après inscription ----------
     L'inscription part sans recharger la page : bouton en chargement, puis la carte se transforme en douceur
     (contenu qui s'efface, hauteur qui s'ajuste, coche qui se dessine, lignes qui arrivent l'une après l'autre).
     Si Shopify demande une vérification anti-robot (hCaptcha) ou répond autrement, on repasse à l'envoi classique. */
  FC.popup = function (racine) {
    var d = racine.querySelector('.fc-modale--popup');
    if (!d) return;
    var cle = 'fc-popup', jours = parseFloat(racine.getAttribute('data-jours') || '7');
    var delai = parseFloat(racine.getAttribute('data-delai') || '10') * 1000;
    var inscrit = !!d.querySelector('[data-fc-inscrit]'), erreurServeur = d.querySelector('[data-fc-erreur]:not([hidden])');
    var editeur = window.Shopify && Shopify.designMode;
    var form = d.querySelector('form.fc-popup__form'), tpl = d.querySelector('template[data-fc-merci]'), carte = d.querySelector('.fc-popup__carte');

    function fermer() {
      FC.fermer(d);
      if (!inscrit && !editeur) ecrireMemoire(cle, 'ferme:' + Date.now());
    }
    brancherFermeture(d, fermer);
    /* délégation : marche aussi pour les boutons ajoutés après l'inscription */
    d.addEventListener('click', function (e) {
      if (e.target.closest('.fc-popup__fermer,[data-fc-fermer-popup]')) { fermer(); return; }
      var cp = e.target.closest('[data-fc-copier]');
      if (cp) {
        var txt = cp.querySelector('[data-fc-copie-texte]');
        var ok = function () { if (txt) txt.textContent = 'Copié'; cp.classList.add('fc-copie'); };
        if (navigator.clipboard) navigator.clipboard.writeText(cp.getAttribute('data-fc-copier')).then(ok, function () {}); else ok();
      }
    });

    /* ----- envoi sans rechargement ----- */
    if (form && tpl && window.fetch && window.DOMParser) form.addEventListener('submit', function (e) {
      if (form.dataset.fcNatif) return;
      e.preventDefault();
      e.stopImmediatePropagation(); /* on gère l'envoi nous-mêmes, jeton anti-robot compris (voir plus bas) */
      var btn = form.querySelector('button[type="submit"]'), champ = form.querySelector('input[type="email"]');
      if (champ && !champ.checkValidity()) { secouer(champ); champ.reportValidity(); return; }
      btn.classList.add('fc-envoi'); btn.disabled = true;
      cacherErreur();
      /* hCaptcha de Shopify : on demande d'abord le jeton invisible (ajouté au formulaire), puis on envoie.
         Sans jeton, Shopify croit à un robot et renvoie vers la page de vérification. */
      if (window.Shopify && Shopify.captcha && typeof Shopify.captcha.protect === 'function') {
        try { Shopify.captcha.protect(form, envoyer); } catch (er) { envoyer(); }
      } else envoyer();

      function envoyer() {
      fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
        .then(function (r) {
          if (/\/challenge/.test(r.url)) return natif();
          if (/customer_posted=true/.test(r.url)) return reussite();
          return r.text().then(function (html) {
            var f = new DOMParser().parseFromString(html, 'text/html').getElementById(form.id);
            if (f && f.querySelector('[data-fc-inscrit]')) return reussite();
            var e2 = f && f.querySelector('[data-fc-erreur]:not([hidden])');
            if (e2 && e2.textContent.trim()) return erreur(e2.textContent.trim());
            natif();
          });
        })
        .catch(natif);
      }

      function natif() { form.dataset.fcNatif = '1'; form.submit(); }
      function erreur(msg) {
        btn.classList.remove('fc-envoi'); btn.disabled = false;
        var el = form.querySelector('[data-fc-erreur]');
        if (el) { el.textContent = msg; el.hidden = false; el.classList.remove('fc-apparait'); void el.offsetWidth; el.classList.add('fc-apparait'); }
        if (champ) { secouer(champ); champ.focus(); }
      }
    });
    function cacherErreur() { var el = form && form.querySelector('[data-fc-erreur]'); if (el) el.hidden = true; }
    function secouer(el) { el.classList.remove('fc-secoue'); void el.offsetWidth; el.classList.add('fc-secoue'); }

    function reussite() {
      inscrit = true; ecrireMemoire(cle, 'inscrit');
      var etat = form.querySelector('.fc-popup__etat');
      var h0 = carte.offsetHeight;
      carte.style.height = h0 + 'px';
      carte.classList.add('fc-redim');
      etat.classList.add('fc-sortie');
      setTimeout(function () {
        etat.innerHTML = '';
        etat.appendChild(tpl.content.cloneNode(true));
        etat.classList.remove('fc-sortie');
        /* la carte prend sa nouvelle hauteur en douceur */
        carte.style.transition = 'none'; carte.style.height = 'auto';
        var h1 = carte.offsetHeight;
        carte.style.height = h0 + 'px'; void carte.offsetHeight;
        carte.style.transition = ''; carte.style.height = h1 + 'px';
        var fin = function (ev) {
          if (ev && ev.propertyName !== 'height') return;
          carte.style.height = ''; carte.classList.remove('fc-redim'); carte.removeEventListener('transitionend', fin);
        };
        carte.addEventListener('transitionend', fin);
        setTimeout(fin, 900);
        var t = etat.querySelector('h2'); if (t) { t.setAttribute('tabindex', '-1'); t.focus({ preventScroll: true }); }
      }, reduit ? 0 : 260);
    }

    /* éditeur de thème : le pop-up s'affiche quand on sélectionne la section */
    if (editeur) {
      document.addEventListener('shopify:section:select', function (e) { if (e.target.contains(racine)) FC.ouvrir(d); });
      document.addEventListener('shopify:section:deselect', function (e) { if (e.target.contains(racine)) FC.fermer(d); });
      return;
    }
    /* retour après un envoi classique : on montre tout de suite le résultat */
    if (inscrit) { ecrireMemoire(cle, 'inscrit'); FC.ouvrir(d); return; }
    if (erreurServeur) { FC.ouvrir(d); return; }
    if (racine.getAttribute('data-actif') !== 'true') return;

    var m = lireMemoire(cle);
    if (m === 'inscrit') return;
    if (m && m.indexOf('ferme:') === 0 && jours > 0 && Date.now() - parseInt(m.slice(6), 10) < jours * 864e5) return;

    /* on attend que l'intro et les autres fenêtres soient terminées */
    function tenter() {
      if (document.documentElement.classList.contains('fc-avec-intro') || document.querySelector('dialog[open]') ||
          document.querySelector('.fc-tiroir.fc-ouvert')) { setTimeout(tenter, 1500); return; }
      FC.ouvrir(d);
    }
    setTimeout(tenter, delai);
  };

  function lancer(scope) {
    (scope || document).querySelectorAll('[data-fc]').forEach(function (r) {
      if (r.dataset.fcPret) return;
      r.dataset.fcPret = '1';
      var f = FC[r.getAttribute('data-fc')];
      if (f) f(r);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { lancer(); });
  else lancer();
  document.addEventListener('shopify:section:load', function (e) { lancer(e.target); });
})();
